import React from "react";
import { Footer, Header } from "../components";
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../store/actions";
import { IUBENTA_POLICY_ID } from "../constants";
import '../Styles/policy.css';

export function CookiePolicy() {
    const dispatch = useDispatch();
    const cookiePolicy = useSelector(state => state.authentication.update_privacy_policy);

    useEffect(() => {
        dispatch(userActions.getPrivacyPolicy(IUBENTA_POLICY_ID, "cookie"));

    }, [])

    return <React.Fragment>
        <Header />
        <Box className="App-content">
            <Typography dangerouslySetInnerHTML={{__html: cookiePolicy}}></Typography>
        </Box>
        <Footer />
    </React.Fragment>
}